module.exports = __webpack_public_path__ + "img/physio_chiro_osteo_splash.e277e491.jpg";